// ── Type de produit : physique ou digital ───────────────────────────
// Un produit digital (livre, vidéo, PDF, pack…) n'a ni stock ni livraison
// physique : le fichier est mis à disposition après l'achat.

export type ProductType = 'physical' | 'digital';

export interface ProductTypeFields {
  product_type?: string | null;
  digital_file_url?: string | null;
  digital_file_name?: string | null;
  digital_delivery_note?: string | null;
}

/** Un produit est digital si son type vaut 'digital'. */
export function isDigitalProduct(product: { product_type?: string | null } | null | undefined): boolean {
  return (product?.product_type || 'physical') === 'digital';
}

/** Libellé lisible du type de produit. */
export function productTypeLabel(type?: string | null): string {
  return (type || 'physical') === 'digital' ? 'Digital' : 'Physique';
}